<template>
  <v-container :class="containerClass" fluid>
    <classroom-form mode="add" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('classrooms.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>Create new classroom</h2>
        </div>
      </template>
    </classroom-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import ClassroomForm from '@components/Classroom/Form'
export default {
  components: {
    ClassroomForm,
  },
  layout: LayoutDashboard,
  methods: {
    onCancel() {
      window.location.href = this.$route('classrooms.index')
    },
  },
}
</script>
